import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import localForage from 'localforage';
import { actionCreators } from '../../../state/modals-dux';

import { reduxForm, Field, FormSection } from 'redux-form';
import FormField from '../../forms/FormField';

const CloneAssetFormComponent = props => {
  const {
    handleSubmit,
    pristine,
    reset,
    submitting,
    cancelEdit,
    showCancel
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="versionName"
        type="text"
        component={FormField.Input}
        label="Cloned Version Name"
        validate={value => value ? undefined : 'Required'}
      />
      <Button
        type="button"
        bsStyle="hollow-info"
        disabled={submitting}
        onClick={cancelEdit}
      >
        <span className="ti ti-close" /> Cancel
      </Button>
      {' '}
      <Button bsStyle="success" type="submit" disabled={submitting}>
        <span className="ti ti-check" /> Submit
      </Button>
    </form>
  );
};

const CloneAssetForm = reduxForm({
  form: 'clone-asset-form' // a unique identifier for this form
})(CloneAssetFormComponent);

class CloneAssetModal extends Component {
  render() {
    const {
      openModal,
      closeModal,
      onCloneSubmit,
      title,
      isEdit,
      initialValues,
      name
    } = this.props;

    const handleCloseModal = () => {
      closeModal();
    };

    const handleSubmit = next =>
      data => {
        closeModal();
        next(data);
      };
    return (
      <Modal show={openModal === name} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{title || 'Clone'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CloneAssetForm
            onSubmit={handleSubmit(onCloneSubmit)}
            initialValues={initialValues || {}}
            cancelEdit={handleCloseModal}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

const mapState = state => ({ openModal: state.modals });
const mapDispatch = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapState, mapDispatch)(CloneAssetModal);



// WEBPACK FOOTER //
// ./src/components/routes/assets/CloneAssetModal.js